import React from 'react';
import { getStyles } from './Icons';
export var ListIcon = function (props) { return (React.createElement("svg", { focusable: "false", style: getStyles(props), viewBox: "0 0 24 24", "aria-hidden": "true", role: "presentation" },
    React.createElement("path", { d: "M19 5v14H5V5zm1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9M11\n       7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z" }),
    "xe")); };
//# sourceMappingURL=ListIcon.js.map